// variablesGlobales.ts
import { Injectable } from '@angular/core';
@Injectable()
export class VariablesGlobales {
    apiKey: string = null;
    ticket: string = null;
    callback_url: string = null;
}



// WEBPACK FOOTER //
// ./src/app/variablesGlobales.ts